<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><span>To the people who will never read this book, the tea labourers of Assam</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0b152444